import styled from "styled-components"
import { FOOTER_STYLED_PROPS } from "./interface"
import { colors } from "lib/colors"

export const Section = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
export const Wrapper = styled.div<FOOTER_STYLED_PROPS>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  opacity: ${({ isDisabled }) => (isDisabled ? 0.6 : 1)};
  transition: opacity 0.5s;
  .clear,
  .new {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    g,
    path {
      stroke: ${colors.tertiaryDark};
    }
  }
  .clear {
    opacity: ${({ isGameActive }) => (isGameActive ? 0 : 1)};
    transition: opacity 0.2s linear;
  }
  .new {
    opacity: ${({ isGameActive }) => (isGameActive ? 1 : 0)};
    transition: opacity 0.2s linear;
    rect {
      fill: ${({ isDisabled }) =>
        isDisabled ? colors.secondaryBackground : colors.secondaryText};
    }
  }
  .stake {
    position: absolute;
    width: 100%;
    height: 16px;
    top: 30px;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    color: ${colors.primaryDark};
    svg {
      height: 9px;
      width: auto;
      margin-right: 2px;
      transform: translateY(1px);
      path {
        fill: ${colors.primaryDark};
        stroke: none;
      }
    }
  }
`
export const AnimatedText = styled.p<FOOTER_STYLED_PROPS>`
  position: absolute;
  width: 100%;
  top: 9px;
  text-align: center;
  opacity: ${({ isGameActive }) => (isGameActive ? 0 : 1)};
  color: ${colors.tertiaryDark};
  transition: opacity 0.4s cubic-bezier(0.08, 0, 0, 1);
  font-size: 18px;
`
export const ButtonWrapper = styled.div<FOOTER_STYLED_PROPS>`
  position: absolute;
  &&.play {
    left: 22%;
    width: ${({ width }) => width};
    transition: width 0.4s cubic-bezier(0.08, 0, 0, 1);
  }
  &&.auto {
    left: 82%;
    opacity: ${({ isGameActive }) => (isGameActive ? 0 : 1)};
    z-index: ${({ isGameActive }) => (isGameActive ? -1 : 1)};
    transition: opacity 467ms cubic-bezier(0.42, 0, 0.09, 1) 167ms;
    g {
      stroke: ${({ isDisabled }) =>
        isDisabled ? colors.secondaryBackground : colors.secondaryText};
    }
  }
`
